import moment from "moment";
import React from "react";
import { useHistory } from "react-router-dom";

import Button from "@/components/UI/Button";
import { Button2 } from "@/ui2/atoms/Button";
import { DashboardCard2 } from "@/components/layout/DashboardCard2";
import { DownloadButton } from "@/ui2/molecules/DownloadButton";
import { getAutomationDataAttr } from "@/utils/automationUtils";

export const MemberProfileFiles = (props) => {
  const { fileList, getFile, viewAllLink } = props;
  const history = useHistory();

  return (
    <DashboardCard2
      Actions={
        <Button2
          className="tw:border-transparent"
          onPress={() => history.push(viewAllLink)}
          size="sm"
          variant="text"
        >
          View All
        </Button2>
      }
      title="Associated Files"
    >
      <div>
        <div className="row mb-2 d-lg-flex d-none tw:font-bold">
          <div className="col-lg-6">File Name</div>
          <div className="col-lg-5">Uploaded Date</div>
          <div className="col-lg-1" />
        </div>

        {fileList &&
          fileList
            .sort((fileA, fileB) => fileB.timestamp > parseInt(fileA.timestamp))
            .slice(0, 2)
            .filter((file) => file)
            .map((file) => {
              const fileName = file.file_key.substring(file.file_key.lastIndexOf("/") + 1);
              const timestamp = moment.utc(file.timestamp).local().format("MM/DD/YYYY HH:mm");

              return (
                <React.Fragment key={file.file_key}>
                  <div className="row mb-2 d-lg-flex d-none">
                    <div className="col-lg-6">{fileName}</div>
                    <div className="col-lg-5">{timestamp}</div>

                    <DownloadButton
                      onPress={() => getFile(file.file_key)}
                      {...getAutomationDataAttr("associated-file-download-button-desktop")}
                    />
                  </div>

                  <div className="mb-2 d-lg-none d-block">
                    <div className="d-flex justify-content-between">
                      <div>
                        <div className="mb-2 tw:font-bold">{fileName}</div>
                        <div>{timestamp}</div>
                      </div>

                      <DownloadButton
                        onPress={() => getFile(file.file_key)}
                        {...getAutomationDataAttr("associated-file-download-button-mobile")}
                      />
                    </div>
                    <hr />
                  </div>
                </React.Fragment>
              );
            })}
      </div>

      <hr />

      {props.showPopUp && (
        <div className="d-flex justify-content-end pb-3 pr-4">
          <Button
            className="Btn Btn--pri Btn-sm ml-4 fs-16 text-center text-white"
            onClick={props.showPopUp}
          >
            Upload File
          </Button>
        </div>
      )}
    </DashboardCard2>
  );
};
